__turbopack_context__.v({
  "blackTextType": "index-module__Ua1O_q__blackTextType",
  "buttonMain": "index-module__Ua1O_q__buttonMain",
  "buttonText": "index-module__Ua1O_q__buttonText",
  "coloredTextType": "index-module__Ua1O_q__coloredTextType",
  "critical": "index-module__Ua1O_q__critical",
  "disabled": "index-module__Ua1O_q__disabled",
  "dropDown": "index-module__Ua1O_q__dropDown",
  "grayTextType": "index-module__Ua1O_q__grayTextType",
  "icon": "index-module__Ua1O_q__icon",
  "indicator": "index-module__Ua1O_q__indicator",
  "large": "index-module__Ua1O_q__large",
  "medium": "index-module__Ua1O_q__medium",
  "noPadding": "index-module__Ua1O_q__noPadding",
  "outline": "index-module__Ua1O_q__outline",
  "primary": "index-module__Ua1O_q__primary",
  "secondary": "index-module__Ua1O_q__secondary",
  "spin": "index-module__Ua1O_q__spin",
  "spinner": "index-module__Ua1O_q__spinner",
  "tertiary": "index-module__Ua1O_q__tertiary",
});
